import { ConcreteEncodable } from "./ConcreteEncodable";

import { AccountImplEncoder } from "../../encoder/AccountImplEncoder";

import * as CubiqTS from "../../index";
import { Account } from "../Account";

export class AccountImpl extends ConcreteEncodable implements Account {
  public static enType: string = "com.bcdfx.model.AccountImpl";

  /*FID=1*/
  public clientId: string;
  /*FID=2*/
  public bookingCode: string;
  /*FID=3*/
  public bookingType: CubiqTS.AccountBookingType;
  /*FID=4*/
  public id: string;
  /*FID=5*/
  public name: string;
  /*FID=6*/
  public creditCheckFg: boolean;
  /*FID=7*/
  public contact: string;
  /*FID=8*/
  public salesGroupId: CubiqTS.Long | null = null;
  /*FID=9*/
  public ordersEnabledFg: boolean;
  /*FID=10*/
  public clientAutoFillEnabled: boolean;
  /*FID=11*/
  public associatedClients: Array<string> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AccountImplEncoder.Instance;
    this.setEncodableType(AccountImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AccountImpl[" +
      "clientId=" +
      this.clientId +
      "bookingCode=" +
      this.bookingCode +
      "bookingType=" +
      this.bookingType +
      "id=" +
      this.id +
      "name=" +
      this.name +
      "creditCheckFg=" +
      this.creditCheckFg +
      "contact=" +
      this.contact +
      "salesGroupId=" +
      this.salesGroupId +
      "ordersEnabledFg=" +
      this.ordersEnabledFg +
      "clientAutoFillEnabled=" +
      this.clientAutoFillEnabled +
      "associatedClients=" +
      this.associatedClients +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
